var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: _vm.title == "调薪弹窗" ? "680px" : "470px",
            "show-close": _vm.status == "add" ? false : true,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "header", attrs: { slot: "title" }, slot: "title" },
            [
              _c("span", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _vm.status == "add"
                ? _c(
                    "el-link",
                    {
                      attrs: { underline: false, icon: "el-icon-edit-outline" },
                      on: { click: _vm.editFn },
                    },
                    [_vm._v("编辑字段")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _vm.status == "add"
            ? _c(
                "div",
                { staticClass: "from" },
                [
                  _vm.title !== "调薪弹窗"
                    ? _c(
                        "el-form",
                        {
                          ref: "formName",
                          staticClass: "demo-dynamic",
                          attrs: {
                            "label-width": "100px",
                            "label-position": "right",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "生效时间:",
                                rules: [
                                  {
                                    type: "date",
                                    required: true,
                                    message: "请选择日期",
                                    trigger: "change",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  placeholder: "选择日期",
                                },
                                model: {
                                  value: _vm.take_date,
                                  callback: function ($$v) {
                                    _vm.take_date = $$v
                                  },
                                  expression: "take_date",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.fromItem, function (item, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: item.label } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: item.placeholder,
                                        type: "number",
                                        maxLength: "9",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.handleInput(
                                            item.value,
                                            index
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.blurVal(item.value, index)
                                        },
                                      },
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "调薪备注：", prop: "desc" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "260px" },
                                attrs: {
                                  type: "textarea",
                                  placeholder:
                                    "请输入调薪备注，最多可输入200字",
                                  maxlength: "200",
                                },
                                model: {
                                  value: _vm.mark,
                                  callback: function ($$v) {
                                    _vm.mark = $$v
                                  },
                                  expression: "mark",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { staticClass: "footer" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  on: { click: _vm.restFn },
                                },
                                [_vm._v("取消")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.loading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.okFn("formName")
                                    },
                                  },
                                },
                                [_vm._v("确定")]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.title == "调薪弹窗"
                    ? _c(
                        "el-form",
                        {
                          ref: "formName",
                          staticClass: "demo-dynamic",
                          attrs: {
                            "label-width": "120px",
                            "label-position": "right",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "生效时间:",
                                rules: [
                                  {
                                    type: "date",
                                    required: true,
                                    message: "请选择日期",
                                    trigger: "change",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "change-item" },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      "value-format": "yyyy-MM-dd",
                                      type: "date",
                                      placeholder: "选择日期",
                                    },
                                    model: {
                                      value: _vm.take_date,
                                      callback: function ($$v) {
                                        _vm.take_date = $$v
                                      },
                                      expression: "take_date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.fromItem, function (item, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: item.label } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "change-item" },
                                      [
                                        _c("el-input", {
                                          staticClass: "disabled-item",
                                          attrs: { disabled: true },
                                          model: {
                                            value: item.num,
                                            callback: function ($$v) {
                                              _vm.$set(item, "num", $$v)
                                            },
                                            expression: "item.num",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "el-icon-d-arrow-right",
                                        }),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: item.placeholder,
                                            type: "number",
                                            maxLength: "9",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.handleInput(
                                                item.value,
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value: item.value,
                                            callback: function ($$v) {
                                              _vm.$set(item, "value", $$v)
                                            },
                                            expression: "item.value",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "调薪备注：", prop: "desc" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  placeholder:
                                    "请输入调薪备注信息，最多可输入200字",
                                  maxlength: "200",
                                },
                                model: {
                                  value: _vm.mark,
                                  callback: function ($$v) {
                                    _vm.mark = $$v
                                  },
                                  expression: "mark",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { staticClass: "footer" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  on: { click: _vm.restFn },
                                },
                                [_vm._v("取消")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.okFn("formName")
                                    },
                                  },
                                },
                                [_vm._v("确定")]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.status === "edit"
            ? _c("div", { staticClass: "addForm" }, [
                _c("div", { staticClass: "assess-right v-height-flag" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "draggable",
                        {
                          attrs: {
                            "chosen-class": "chosen",
                            "force-fallback": "true",
                            group: "people",
                            animation: "1000",
                          },
                          on: { start: _vm.onStart, end: _vm.onEnd },
                          model: {
                            value: _vm.fromItem,
                            callback: function ($$v) {
                              _vm.fromItem = $$v
                            },
                            expression: "fromItem",
                          },
                        },
                        [
                          _c(
                            "transition-group",
                            _vm._l(_vm.fromItem, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "item-list" },
                                [
                                  _c("i", {
                                    staticClass:
                                      "icon iconfont icontuodong item-drag",
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: {
                                      clearables: "",
                                      "show-word-limit": "",
                                      placeholder: "请输入表单字段",
                                    },
                                    model: {
                                      value: item.label,
                                      callback: function ($$v) {
                                        _vm.$set(item, "label", $$v)
                                      },
                                      expression: "item.label",
                                    },
                                  }),
                                  _vm._v(" "),
                                  item.sort !== 1 && item.sort !== 2
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-remove item-remove",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDelete(index)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "add-type mt14",
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.handleAddType()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v(" 添加"),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "footer" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              on: { click: _vm.handleResetFn },
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.handleConfirm },
                            },
                            [_vm._v("确定")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }